/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';
import { Appraisal } from '../models/Appraisal';
import { Pagination } from '../models';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppraisalService extends BaseApiService<Appraisal> {
  get cacheKey(): StorageKey {
    return StorageKey.appraisalServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.omniaCoreApiUrl}/v1/appraisals`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  list(params: any = {}): Promise<Pagination<Appraisal>> {
    return super.list({ limit: 1000, ...params });
  }

  public equipmentAppraisalReport(id, params = {}) {
    const url = `${environment.omniaCoreApiUrl}/v1/report/equipmentAppraisalReport/${encodeURIComponent(id)}`;
    const httpParams = new HttpParams({
      fromObject: params as { [params: string]: string }
    });
    const req: Observable<any> = this.http.get(url, { params: httpParams });
    return req.pipe(
      catchError((responseError) => this.handleError(responseError))
    ).toPromise();
  }

  protected parse(obj) {
    const parsed = Appraisal.parse(obj) as any;
    const { id, ...rest } = parsed;
    return rest;
  }

  protected unparse(obj) {
    return Appraisal.unparse(obj);
  }
}
